import axios from "axios";
import React, { createContext, useState, useEffect } from "react";
import axiosInstance from "../utils/axiosInstance";
import { toast } from "react-toastify";
import { session } from "../utils/session";
import { decryptPayload, encryptPayload } from "../utils/encryptDecrypt";

// Create the AuthContext
/* The line `export const AuthContext = createContext<AuthContextValue | undefined>(undefined);` is
creating a new context object called `AuthContext` using the `createContext` function provided by
React. */
export const AuthContext = createContext(undefined);

/**
 * The `AuthProvider` component is a React functional component that provides authentication
 * functionality to its child components.
 * @param  - - `Props`: The type of props that the `AuthProvider` component accepts.
 * @returns The `AuthProvider` component is returning the `children` prop wrapped in the
 * `AuthContext.Provider` component.
 */
export const AuthProvider = ({ children }) => {
  // State to track the authenticated user
  const [user, setUser] = useState(null);
  const secretkey = process.env.REACT_APP_SECRET_KEY;
  // Function to handle user login
  const login = (userData) => {
    try {
      console.log("UserData while login:", userData);
      setUser(userData?.user);
      const encryptedValues = encryptPayload(userData?.user, secretkey);
      session.setCookie("_auth", JSON.stringify({ user: encryptedValues }), 1);
      toast("User authenticated Successfully !", { type: "success" });
    } catch (e) {
      console.error("Error while login:", e);
    }
  };

  // Function to handle user logout
  const logout = () => {
    // Perform logout logic here...
    session.eraseCookie("_auth");
    session.eraseCookie("api_token"); // Since this is http only it will not work
    setUser(null);
    toast("User Logged Out Successfully", { type: "success" });

    return;
    axiosInstance
      .post("/api/auth/signout", {})
      .then((res) => {
        if (res.status === 200) {
          console.log("response data", res.data);
          // await window.localStorage("api_token", res.data.api_token);
          // Clear the token cookie
          document.cookie = `api_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

          setUser(null);
        }
      })
      .catch((error) => {
        console.log("something went wrong", error.response.data.message);
        if (error?.response?.data?.message)
          alert(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const _auth = session.getCookie("_auth");
        const encryptedData = JSON.parse(_auth)?.user;
        if (!encryptedData) return;
        const user = decryptPayload(encryptedData, secretkey);
        setUser(user);
        console.log("Authentication Verified", encryptedData, user);
      } catch (error) {
        console.error("Error checking authentication:", error);
      }
    };

    checkAuth();
  }, []);

  // Value object to be provided to consuming components
  const authContextValue = {
    user,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};
